import { render, staticRenderFns } from "./product-registration-details.vue?vue&type=template&id=56e8e349&scoped=true&"
import script from "./product-registration-details.vue?vue&type=script&lang=tsx&"
export * from "./product-registration-details.vue?vue&type=script&lang=tsx&"
import style0 from "./product-registration-details.vue?vue&type=style&index=0&id=56e8e349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8e349",
  null
  
)

export default component.exports